// eslint-disable-next-line import/prefer-default-export
export const SET_COTACAO_ID_AC = 'setCotacaoId';
